import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const UNITS_OF_MEASURE_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('UNITS_OF_MEASURE');
export const UNITS_OF_MEASURE_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	UNITS_OF_MEASURE_CRUD_ACTION_CONSTANTS
);
